import ServiceBus from 'servicestack/service-bus'

class DashboardTopVendorsController  {
    constructor(createAutoQuery, $session) {
        this.$session = $session;
    }

    load() {
        let $ctrl = this;
        var bus = new ServiceBus();
        var request = {
            reportName: "DashboardSalesByRepGroupByVendor",
            dateRange: "YTD",
            status: "Open,Review,Completed,On Hold"
        }
        bus.send('RunReport.json', request).then(function (response) {
            $ctrl.query = response.data; 
        });
    }
}

class DashboardTopVendors{
    constructor(){
        this.bindings= {
            date: '@',
        };
        this.controller = DashboardTopVendorsController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'dashboard-top-vendors.html'
    }
}

angular.module('emun.shopping.admin').component('dashboardTopVendors', new DashboardTopVendors());

export default DashboardTopVendors